import firebase from 'firebase';
import 'firebase/firestore';
import firebaseConfig from "./firebaseConfig";
const firebaseApp = firebase.initializeApp(firebaseConfig);

export default {
    db: firebaseApp.firestore(),
    storage: firebaseApp.storage()
};